import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SkeletonAppearance } from './skeleton-apperance';

@Component({
  selector: 'ctr-image-skeleton',
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './image-skeleton.component.html',
  styleUrl: './image-skeleton.component.scss',
})
export class ImageSkeletonComponent {
  @Input() imageUrl: string | undefined;
  @Input() height = '100%';
  @Input() width = '100%';
  @Input() borderRadius = '0';
  @Input() skeletonAppearance: SkeletonAppearance = SkeletonAppearance.CIRCLE;
  isLoading = true;

  onLoad() {
    this.isLoading = false;
  }
}
